<section class="page-404 mt--50 py-0">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 d-flex align-items-center vh-100 error-wrapper">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-6" style="display: none;">
                        <h1 class="error-code">Wcrg</h1>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <h2 class="error-title">Coming soon page</h2>
                        <p class="error-desc" >Sorry, this page is under construction. We will inform you when it is finished
                        </p>
                        <a routerLink="/" class="btn btn__primary btn__icon">
                            <span>Back To Home</span> <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>